const components = {
  MuiCssBaseline: {
    styleOverrides: {
      '*': {
        boxSizing: 'border-box',
      },
      html: {
        MozOsxFontSmoothing: 'grayscale',
        WebkitFontSmoothing: 'antialiased',
        height: '100%',
        width: '100%',
      },
      body: {
        height: '100%',
      },
      '#root': {
        height: '100%',
      },
      a: {
        textDecoration: 'none',
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 4,
        textTransform: 'none',
        fontWeight: 500,
        boxShadow: 'none',
        '&:hover': {
          boxShadow: 'none',
        },
      },
      contained: {
        '&:hover': {
          boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
        },
      },
      sizeSmall: {
        padding: '6px 16px',
        fontSize: '0.8125rem',
      },
      sizeMedium: {
        padding: '8px 20px',
      },
      sizeLarge: {
        padding: '11px 24px',
        fontSize: '0.9375rem',
      },
    },
    defaultProps: {
      disableElevation: true,
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        boxShadow: '0 0.75rem 1.5rem rgba(18, 38, 63, 0.03)',
      },
    },
  },
  MuiCardHeader: {
    styleOverrides: {
      root: {
        padding: '1rem 1.25rem',
      },
      title: {
        fontSize: '1rem',
        fontWeight: 600,
      },
    },
  },
  MuiCardContent: {
    styleOverrides: {
      root: {
        padding: '1.25rem',
        '&:last-child': {
          paddingBottom: '1.25rem',
        },
      },
    },
  },
  MuiTextField: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-root': {
          borderRadius: 4,
        },
      },
    },
    defaultProps: {
      size: 'small',
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: 4,
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: '#2AB63F',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#2AB63F',
        },
      },
      input: {
        padding: '10px 14px',
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        '&.Mui-focused': {
          color: '#2AB63F',
        },
      },
    },
  },
  MuiTableHead: {
    styleOverrides: {
      root: {
        backgroundColor: '#f8f9fa',
        '& .MuiTableCell-head': {
          fontWeight: 600,
          color: '#495057',
          borderBottom: '2px solid #e9ecef',
        },
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        padding: '12px 16px',
        borderBottom: '1px solid #e9ecef',
      },
    },
  },
  MuiTableRow: {
    styleOverrides: {
      root: {
        '&:hover': {
          backgroundColor: 'rgba(42, 182, 63, 0.04)',
        },
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: 4,
        fontWeight: 500,
      },
      sizeSmall: {
        height: 24,
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: 'none',
      },
      rounded: {
        borderRadius: 8,
      },
      elevation1: {
        boxShadow: '0 0.75rem 1.5rem rgba(18, 38, 63, 0.03)',
      },
    },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: {
        borderRight: 'none',
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        boxShadow: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)',
      },
    },
  },
  MuiListItemButton: {
    styleOverrides: {
      root: {
        borderRadius: 4,
        marginBottom: 4,
        '&.Mui-selected': {
          backgroundColor: '#2AB63F',
          color: '#ffffff',
          '&:hover': {
            backgroundColor: '#1a8a2d',
          },
          '& .MuiListItemIcon-root': {
            color: '#ffffff',
          },
        },
        '&:hover': {
          backgroundColor: 'rgba(42, 182, 63, 0.08)',
        },
      },
    },
  },
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        minWidth: 40,
        color: '#2AB63F',
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        fontWeight: 500,
        fontSize: '0.9375rem',
        '&.Mui-selected': {
          color: '#2AB63F',
        },
      },
    },
  },
  MuiTabs: {
    styleOverrides: {
      indicator: {
        backgroundColor: '#2AB63F',
      },
    },
  },
  MuiAlert: {
    styleOverrides: {
      root: {
        borderRadius: 4,
      },
      standardSuccess: {
        backgroundColor: 'rgba(42, 182, 63, 0.1)',
        color: '#1a8a2d',
      },
    },
  },
  MuiBadge: {
    styleOverrides: {
      colorPrimary: {
        backgroundColor: '#2AB63F',
      },
    },
  },
  MuiAvatar: {
    styleOverrides: {
      root: {
        fontSize: '1rem',
        fontWeight: 500,
      },
    },
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        backgroundColor: '#212529',
        fontSize: '0.75rem',
      },
    },
  },
  MuiPagination: {
    styleOverrides: {
      root: {
        '& .MuiPaginationItem-root.Mui-selected': {
          backgroundColor: '#2AB63F',
          color: '#ffffff',
          '&:hover': {
            backgroundColor: '#1a8a2d',
          },
        },
      },
    },
  },
  MuiSwitch: {
    styleOverrides: {
      switchBase: {
        '&.Mui-checked': {
          color: '#2AB63F',
          '& + .MuiSwitch-track': {
            backgroundColor: '#2AB63F',
          },
        },
      },
    },
  },
  MuiCheckbox: {
    styleOverrides: {
      root: {
        '&.Mui-checked': {
          color: '#2AB63F',
        },
      },
    },
  },
  MuiRadio: {
    styleOverrides: {
      root: {
        '&.Mui-checked': {
          color: '#2AB63F',
        },
      },
    },
  },
};

export default components;
